import { observable, action, runInAction } from 'mobx'
import React from 'react'
import Api from '@api/xiu_yan/jukeTreasureApi'
import { toTimestamp } from '@hlj/hlj-utils'
import { MERCHANT_CONSULT_PHONE } from '@hlj/hlj-constant'
import { message, Modal } from 'hljd'
import { JUKE_PATH_A } from '@constant'

const confirm = Modal.confirm

class Store {
  id
  type

  @observable list = []
  @observable total = 1
  @observable
  pagination = {
    current: 1,
    pageSize: 15,
    total: 1
  }

  @action
  setPage = page => {
    this.pagination.current = page.current
    this.getList(page.current)
  }

  @observable timer
  @observable d = 0
  @observable h = 0
  @observable m = 0
  @observable s = 0
  @observable activity = {}
  @action
  getList = async page => {
    const { pagination, id, luckStatus, presentStatus } = this

    let luckParams = {}
    if (luckStatus) {
      if (luckStatus == 1) {
        luckParams = {
          'status[0]': 2,
          'status[1]': 3
        }
      } else {
        luckParams = {
          status: 1
        }
      }
    }

    let presentParams = {}
    if (presentStatus) {
      presentParams = {
        status: presentStatus
      }
    }

    let params = {
      per_page: 15,
      page: page ? page : pagination.current,
      activity_id: id,
      ...luckParams,
      ...presentParams
    }
    let {
      data: { activity, list }
    } = await Api.enroll(params)
    runInAction(() => {
      this.activity = activity
      this.list = list

      this.timer = setInterval(() => {
        let end = toTimestamp(activity.sign_up_end_time)
        let now = toTimestamp()
        let rest = end - now

        if (rest > 0) {
          this.d = parseInt(rest / 1000 / 60 / 60 / 24)
          this.h =
            parseInt((rest / 1000 / 60 / 60) % 24) > 9
              ? parseInt((rest / 1000 / 60 / 60) % 24)
              : '0' + parseInt((rest / 1000 / 60 / 60) % 24)
          this.m =
            parseInt((rest / 1000 / 60) % 60) > 9
              ? parseInt((rest / 1000 / 60) % 60)
              : '0' + parseInt((rest / 1000 / 60) % 60)
          this.s =
            parseInt((rest / 1000) % 60) > 9
              ? parseInt((rest / 1000) % 60)
              : '0' + parseInt((rest / 1000) % 60)
        } else {
          clearInterval(this.timer)
          return false
        }
      }, 1000)
    })
  }

  @observable balance = 0
  @observable num = 0
  @action
  getPayView = async () => {
    const { id } = this
    let {
      data: { balance, num }
    } = await Api.pay_view({ id })
    runInAction(() => {
      this.balance = balance
      this.num = num
    })
  }

  @observable remark = ''
  @action
  changeRemark = e => {
    this.remark = e.target.value
  }

  @observable remarkId
  @observable remarkVisible = false
  @action
  showRemarkModal = (value, id) => () => {
    this.remark = value
    this.remarkId = id
    this.remarkVisible = true
  }

  @action
  hideRemarkModal = () => {
    this.remark = ''
    this.remarkId = ''
    this.remarkVisible = false
  }

  @action
  addRemark = async () => {
    const { remark, remarkId } = this
    let params = {
      remark,
      id: remarkId
    }
    let { success } = await Api.remark(params)
    if (success) {
      message.success('操作成功！')
      this.hideRemarkModal()
      this.getList()
    }
  }

  @action
  chargeNum = () => {
    const {
      activity: { sign_up_end_time },
      num,
      balance
    } = this

    let content
    if (toTimestamp(sign_up_end_time) > toTimestamp()) {
      content = <p key={1}>活动点不足，充值活动点后可联系用户</p>
    } else {
      content = (
        <div key={0}>
          <p>活动点不足</p>
          <p>需消耗活动点：{num}</p>
          <p>您的活动点剩余：{balance}点</p>
          <p style={{ color: '#aaa' }}>(重复报名用户不消耗活动点)</p>
        </div>
      )
    }

    confirm({
      content: content,
      okText: '充值活动点',
      iconType: 'exclamation-circle-o',
      onOk: () => {
        window.location.href = `${JUKE_PATH_A}/buy`
      }
    })
  }

  @observable searchVal = ''
  @action
  changeSearchVal = e => {
    this.searchVal = e.target.value
  }

  @action
  contentSearch = async () => {
    const { id, searchVal } = this

    let searchParams = {}
    if (Number(searchVal)) {
      searchParams = { user_tel: searchVal }
    } else {
      searchParams = { realname: searchVal }
    }

    let params = {
      per_page: 15,
      page: 1,
      activity_id: id,
      ...searchParams
    }
    let {
      data: { list }
    } = await Api.enroll(params)
    runInAction(() => {
      this.list = list
    })
  }

  @observable luckStatus = ''
  @action
  changeLuckStatus = value => {
    this.luckStatus = value
    this.getList()
  }

  @observable presentStatus = ''
  @action
  changePresentStatus = value => {
    this.presentStatus = value
    this.getList()
  }

  showTips = () => {
    Modal.info({
      iconType: 'none',
      title: '活动点不足，充值活动点后可联系用户',
      content: (
        <div style={{ color: '#f83244', fontSize: 16 }}>
          请联系客服（{MERCHANT_CONSULT_PHONE}）处理
        </div>
      )
    })
  }
}
export default new Store()
